class Account {
  accountId: number;
  accountNumber: string;
  alias: string;
  productDescription: string;
  currency: string;
  availableBalance: number;
  bookBalance: number;
  created: string;
  lastUpdated: string;
  accountRelationDescription: string;
  iban: string;
  isEnabled: boolean;
  productId: number;
  beneficiary: string;

  constructor(
    accountId: number,
    accountNumber: string,
    alias: string,
    productDescription: string,
    currency: string,
    availableBalance: number,
    bookBalance: number,
    created: string,
    lastUpdated: string,
    accountRelationDescription: string,
    iban: string,
    isEnabled: boolean,
    productId: number,
    beneficiary: string,
  ) {
    this.accountId = accountId;
    this.accountNumber = accountNumber;
    this.alias = alias;
    this.productDescription = productDescription;
    this.currency = currency;
    this.availableBalance = availableBalance;
    this.bookBalance = bookBalance;
    this.created = created;
    this.lastUpdated = lastUpdated;
    this.accountRelationDescription = accountRelationDescription;
    this.iban = iban;
    this.isEnabled = isEnabled;
    this.productId = productId;
    this.beneficiary = beneficiary;
  }
}

export { Account };
